import React, { Component } from 'react';

export class Field extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e, key) {
    this.props.onChange(e.target.value, key);
  }

  render() {
    const { className, styles, select, type, label, value, min, max, step } = this.props;
    return (
      <p className={className} style={styles}>
        <label htmlFor={select}>{label}</label>
        <input id={select} type={type} value={value} min={min} max={max} step={step} onChange={ (e) => this.handleChange(e, select) }  />
      </p>
    );
  }
}

Field.defaultProps = {
  className: 'field',
  styles: null,
  type: 'text',
  min: null,
  max: null,
  step: null,
}

export default Field;
